import apolloClient from "@/apollo/apollo";
import gql from "graphql-tag";

const state = {
    patientRequests: [],
};

const getters = {
    getAllPatientRequests: (state) => state.patientRequests,
};

const mutations = {
    setAllPatientRequests(state, patientRequests) {
        state.patientRequests = patientRequests.slice();
    },
};

const actions = {
    async fetchAllPatientRequests({ commit }, { status, page, size }) {
        try {
            const response = await apolloClient.query({
                query: gql`
          query findAllPatientRequests($status: RequestStatusEnum, $page: Int, $size: Int) {
            findAllPatientRequests(status: $status, page: $page, size: $size) {
              content {
                id
                title
                description
                status
                staffNotes
                processedDate
                creationDate
                requestType {
                  id
                  name
                }
                patient {
                  id
                  contact {
                    fullName
                  }
                }
                user {
                  id
                  contact {
                    fullName
                  }
                }
                processedBy {
                  id
                  contact {
                    fullName
                  }
                }
              }
              totalPages
              totalElements
              number
              size
            }
          }
        `,
                variables: { status, page: page || 0, size: size || 15 },
                context: {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("accessToken"),
                    },
                },
                fetchPolicy: "network-only",
            });
            return response.data.findAllPatientRequests;
        } catch (error) {
            console.error("Failed to fetch patient requests:", error);
            return null;
        }
    },

    async updatePatientRequestStatus({ dispatch }, { id, updateInput }) {
        try {
            const response = await apolloClient.mutate({
                mutation: gql`
          mutation updatePatientRequestStatus($id: Int!, $updateInput: UpdatePatientRequestStatusInput!) {
            updatePatientRequestStatus(id: $id, updateInput: $updateInput) {
              id
              status
              staffNotes
            }
          }
        `,
                variables: { id: +id, updateInput },
                context: {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("accessToken"),
                    },
                },
            });
            return response.data.updatePatientRequestStatus;
        } catch (error) {
            console.error("Failed to update patient request status:", error);
            return null;
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
